class FetchService {
  constructor($http, $rootScope) {
    if ($rootScope.globals)
      $http.defaults.headers.common["Authorization"] =
        "Bearer " + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  getCareType() {
    return this.$http.get(
      "" + WEBSERVICEURL + "/dataagility/api/service.refcode/query?domain=CARE"
    );
  }
}

class TotalauditController {
  constructor(
    $http,
    $scope,
    DTOptionsBuilder,
    DTColumnBuilder,
    User,
    Constants,
    CONST,
    materialButtons,
    datePicker,
    $rootScope,
    $location,
    FunctionService
  ) {
    $http.defaults.headers.common["Authorization"] =
      "Bearer " + $rootScope.globals.currentUser.token;
    this.datatableApi;
    this.user = User.getUser();
    this.name = "Total Audit Summary";
    this.episodeValue = "";
    this.specialtyString = "";
    this.separationString = "";
    this.EOFY = moment("30/06/" + moment().format("YYYY"), "DD/MM/YYYY");
    this.startFinYear;
    this.endFinYear;
    this.startFinYearDisplay;
    this.endFinYearDisplay;

    if (moment().isAfter($scope.vm.EOFY)) {
      this.startFinYear = moment().month("July").startOf("month");
      this.endFinYear = moment().add(1, "year").month("June").endOf("month");
      // TODO - testing remove
      // this.startFinYear = moment().month('July').startOf('month').subtract(1, 'year');
      // this.endFinYear = moment().add(1, 'year').month('June').endOf('month').subtract(1, 'year');
    } else {
      this.startFinYear = moment()
        .subtract(1, "year")
        .month("July")
        .startOf("month");
      this.endFinYear = moment().month("June").endOf("month");
    }

    this.startFinYearDisplay = this.startFinYear.format("L");
    this.endFinYearDisplay = this.endFinYear.format("L");

    this.caretypeOptions = [];
    this.caretype = {
      selectedCaretype: [],
    };
    this.allCareTypeOptions = [];

    this.patientclassOptions = [];
    this.patientclass = {
      selectedPatientclass: [],
    };

    this.specialty = {
      selectedSpecialty: [],
    };
    this.specialtyOptions = {};

    Constants.getDivisionAndSpecialtyData().then(function (response) {
      $scope.vm.specialtyOptions = response.specialties;
      filterSpecialty(response.specialties);
      // Can load divisions if needed??
    });

    Constants.patientClassificationData().then(function successCallback(
      response
    ) {
      $scope.vm.patientclassOptions = response;
    });

    this.locale = "en-au";
    this.url =
      WEBSERVICEURL + "/dataagility/api/service.totalauditsummary/query?";
    this.initUrl =
      this.url +
      "startDate=" +
      $scope.vm.startFinYearDisplay +
      "&endDate=" +
      $scope.vm.endFinYearDisplay +
      "&careType=Acute inc Qual Newborn" +
      "&patientClass=Overseas Non Eligible,Workcover - Acute,Workcover - Non-Acute&specialty=";

    this.dateRange = this.startFinYearDisplay + " - " + this.endFinYearDisplay;

    datePicker.autoClose($scope);

    // callback functions
    this.selectCallback = selectCallback;
    this.filterPatientclass = filterPatientclass;
    this.filterCaretype = filterCaretype;

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue =
          response.functionSettings.EpisodeValue.valueString;
        $scope.vm.episodeValueDecimalPlaces =
          $scope.vm.episodeValue === "$" ? 2 : 4;
        $scope.vm.functionSettings = response.functionSettings;

        Constants.campusData().then(function successCallback(response) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.functionSettings.LimitCampusDropDown &&
            $scope.vm.functionSettings.LimitCampusDropDown.isActive
          ) {
            let campusOptions = [];
            if (typeof $scope.vm.user.campus === "string") {
              campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
            } else {
              campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
            }
            $scope.vm.campusOptions = campusOptions;
            $scope.vm.campus.selectedCampus = campusOptions;
          } else {
            $scope.vm.campusOptions = response;
          }
        });

        $scope.vm.specialtyString =
          response.functionSettings.SpecialtyString.valueString;
        $scope.vm.separationString =
          response.functionSettings.SeparationString.valueString;
      }
    );

    materialButtons.render();

    materialButtons.processing();

    $scope.initCallback = function (
      nRow,
      aData,
      iDisplayIndex,
      iDisplayIndexFull
    ) {
      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi) return;

      $scope.vm.datatableApi = this.api();

      // Update column headers even when no data returned
      setDtHeaders($scope.vm.datatableApi);

      // setup search filters
      search();

      // set the table to a fixed height, so it never collapsed up and down
      $("#auditTable").closest(".dataTables_scrollBody").height(300);
    };

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        headers: {
          Authorization: "Bearer " + $rootScope.globals.currentUser.token,
        },
        url: $scope.vm.initUrl,
        type: "GET",
        error: (xhr, error, thrown) => {
          if (thrown == "Unauthorized") {
            //window.location.replace(window.location.origin + '/login');
            console.log(
              "Unauthorized request with token: ",
              $rootScope.globals.currentUser.token
            );
          }
        },
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp("data")
      .withOption("processing", true)
      // .withOption('serverSide', true)
      .withOption("sAjaxDataProp", "")
      .withOption("bLengthChange", false)
      .withPaginationType("simple_numbers")
      .withOption("initComplete", $scope.initCallback)
      .withOption("rowCallback", function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($("#auditTable").DataTable());
      })
      .withOption("scrollY", "300px")
      .withOption("scrollX", "auto")
      .withOption("dom", '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: "print",
          text: "",
        },
        {
          extend: "csvHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          extend: "excelHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          text: "",
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          },
        },
      ])
      .withColumnFilter({
        //sPlaceHolder: "head:after",
        aoColumns: [
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
        ],
      });

    this.dtColumns = [
      DTColumnBuilder.newColumn("campus")
        .withTitle("Campus")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .notVisible(),
      DTColumnBuilder.newColumn("totalEpisodes")
        .withTitle("Total<br>Episodes")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalEpisodesRequireAudit")
        .withTitle("Total Episodes<br>Required for Audit")
        .withOption("width", "5%")
        .withOption("defaultContent", "")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("percentageMeetCriteria")
        .withTitle("Episodes that<br>Meet Criteria (%)")
        .withOption("width", "5%")
        .withOption("defaultContent", "")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalEpisodesAudited")
        .withTitle("Total<br>Episodes Audited")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("percentageAudited")
        .withTitle("Total<br>Episodes Audited (%)")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("percentageToBeAudited")
        .withTitle("Episodes<br>to be Audited (%)")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalCodingChange")
        .withTitle("Total Episodes<br>With Coding Changes")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalDRGChange")
        .withTitle("Total Episodes<br>with DRG Change ")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("WIESPerEpisode")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          if (full.totalEpisodes > 0)
            return parseFloat(data).toFixed(
              $scope.vm.episodeValueDecimalPlaces
            );
        }),
      DTColumnBuilder.newColumn("sumTotalWIESChange")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          if (full.totalEpisodes > 0)
            return parseFloat(data).toFixed(
              $scope.vm.episodeValueDecimalPlaces
            );
        }),
      DTColumnBuilder.newColumn("totalFinalWies")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          if (full.totalEpisodes > 0)
            return parseFloat(data).toFixed(
              $scope.vm.episodeValueDecimalPlaces
            );
        }),
      DTColumnBuilder.newColumn("targetWIES")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("WIESDifference")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("WIESDIfferencePercentage")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
    ];

    // Search filters
    this.locale = "en-au";
    this.startDatePicker = {
      input: {
        date: $scope.vm.startFinYear,
        dateFormatted: $scope.vm.startFinYearDisplay,
      },
    };
    this.endDatePicker = {
      input: {
        date: $scope.vm.startFinYear,
        dateFormatted: $scope.vm.endFinYearDisplay,
      },
    };

    function setDtHeaders(table) {
      $(table.column(9).header()).html(
        $scope.vm.episodeValue + "<br>Per Episode"
      );
      $(table.column(10).header()).html(
        "Total<br>" + $scope.vm.episodeValue + " Change"
      );
      $(table.column(11).header()).html("Total<br>" + $scope.vm.episodeValue);
      $(table.column(12).header()).html("Target<br>" + $scope.vm.episodeValue);
      $(table.column(13).header()).html(
        $scope.vm.episodeValue + "<br>difference"
      );
      $(table.column(14).header()).html(
        $scope.vm.episodeValue + "<br>difference (%)"
      );
    }

    function checkParam(param) {
      if (param.length !== 0) {
        return encodeURIComponent(param.join());
      } else {
        return "";
      }
    }

    function checkParamCare(param) {
      let codes = [];

      if (param.length !== 0) {
        angular.forEach(param, function (value, key) {
          codes.push(value.code);
        });

        return encodeURIComponent(codes.join());
      } else {
        return "";
      }
    }

    this.campusCallback = campusCallback;

    function campusCallback(_newValue, _oldValue) {
      $scope.reload();
    }

    this.filterCampus = filterCampus;

    function filterCampus(modifier) {
      $scope.vm.campus.selectedCampus = [];
      if (modifier === "add") {
        $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
      }
    }

    function filterSpecialty(swap) {
      $scope.vm.specialty.selectedSpecialty = [];
      if (swap === "add") {
        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
      }
    }

    // bind filter swap
    this.filterSwap = filterSwap;

    function filterSwap(thisFilter, thisModifier) {
      switch (thisFilter) {
        case "specialty":
          if (thisModifier === "add") {
            filterSpecialty("add");
          } else {
            filterSpecialty("minus");
          }
          break;
        case "campus":
          if (thisModifier === "add") {
            filterCampus("add");
          } else {
            filterCampus("minus");
          }
          break;
        default:
          break;
      }
    }

    $scope.reload = function () {
      if ($scope.vm.datatableApi) {
        var campus = "";
        if (
          $scope.vm.functionSettings.LimitCampusDropDown &&
          $scope.vm.functionSettings.LimitCampusDropDown.isActive
        ) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.campus.selectedCampus.length === 0
          ) {
            campus = $scope.vm.user.campus;
          } else {
            if ($scope.vm.campus) {
              campus = $scope.vm.campus.selectedCampus;
            } else {
              campus = ""
            }
          }
        } else {
          if ($scope.vm.campus) {
            campus = $scope.vm.campus.selectedCampus;
          } else {
            campus = ""
          }
        }
        let newUrl =
          $scope.vm.url +
          "startDate=" +
          $scope.vm.startDatePicker.input.dateFormatted +
          "&endDate=" +
          $scope.vm.endDatePicker.input.dateFormatted +
          "&careType=" +
          checkParamCare($scope.vm.caretype.selectedCaretype) +
          "&patientClass=" +
          checkParam($scope.vm.patientclass.selectedPatientclass) +
          "&specialty=" +
          checkParam($scope.vm.specialty.selectedSpecialty) +
          "&campus=" +
          campus +
          "";

        // update dates in heading
        $scope.vm.dateRange =
          $scope.vm.startDatePicker.input.dateFormatted +
          " - " +
          $scope.vm.endDatePicker.input.dateFormatted;

        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
      }
    };

    function search() {
      // delete any global searches previously applied
      if ($.fn.dataTable.ext.search.length === 1)
        $.fn.dataTable.ext.search.shift();

      var auditTable = $scope.vm.datatableApi;
      var clearAuditTable = auditTable.search("").draw();

      filterSpecialty("minus");

      // re-draw tabele on datepicker close
      $scope.$on("lx-date-picker__close-start", function (e, id) {
        $scope.reload();
      });
    }

    $scope.getCareType = function () {
      new FetchService($http, $scope).getCareType().then(
        function successCallback(response) {
          angular.forEach(response.data, function (value, key) {
            $scope.vm.caretypeOptions.push(value);

            if (value.description === "Acute inc Qual Newborn")
              $scope.vm.caretype.selectedCaretype.push(
                $scope.vm.caretypeOptions[key]
              );
          });
        },
        function errorCallback(response) {
          // $scope.feedback = "Error loading data";
          if (response.status === 401) {
            window.location.replace(
              window.location.origin + "/login?logout=true"
            );
          }
        }
      );
    };

    $scope.getCareType();

    function selectCallback(_newValue, _oldValue) {
      $scope.reload();
    }

    function filterCaretype(swap) {
      $scope.vm.caretype.selectedCaretype = [];

      if (swap !== "minus") {
        angular.forEach($scope.vm.caretypeOptions, function (value, key) {
          $scope.vm.caretype.selectedCaretype.push(value);
        });
      }
    }

    function filterPatientclass(swap) {
      $scope.vm.patientclass.selectedPatientclass = [];

      if (swap !== "minus") {
        $scope.vm.patientclass.selectedPatientclass =
          $scope.vm.patientclassOptions;
      }
    }

    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {
      $scope.dtInstance = dtInstance._renderer;
    }
  }
}

export default TotalauditController;



// WEBPACK FOOTER //
// ./client/app/common/reports/totalaudit/totalaudit.controller.js